import router from "./router";
import store from "./store/";
import { ls } from "@/utils//cache";
import { USERINFO } from "@/store/mutation-types";

const whiteList = ["notInDingTalk", "noPermissions"]; //路由白名单

router.beforeEach(async (to, from, next) => {
  const userInfo = ls.get(USERINFO) || {};
  if (whiteList.includes(to.name)) {
    next();
  } else if (!userInfo.Permissions) {
    store.dispatch("user/login").then(() => {
      next();
    });
  } else {
    next();
  }

  if (to.meta.title) {
    document.title = to.meta.title;
  }
});

router.afterEach(() => {});
